import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ElementTypeListComponent } from './element-type-list.component';

@NgModule({
  declarations: [ElementTypeListComponent],
  imports: [CommonModule, MatSlideToggleModule],
  exports: [ElementTypeListComponent],
})
export class ElementTypeListModule { }
